<template>
  <basic-container v-loading="loading">
    <h4>{{ form.id ? '编辑司机提成' : '新增司机提成' }}</h4>

    <el-form ref="form" :model="form" :rules="rules" label-width="200px" class="form">
      <el-form-item label="提成规则名称" prop="ruleName">
        <el-input
          v-model="form.ruleName"
          placeholder="请输入提成规则名称"
          clearable
          style="width: 300px"
          maxlength="20"
          show-word-limit
          :disabled="form.id"
        />
      </el-form-item>

      <!-- 新用户提成比例配置 -->
      <el-form-item label="新用户下单提成比例设置" required>
        <el-table :data="newUserTableData" style="width: 100%" border>
          <el-table-column prop="role" label="角色" width="180px" />
          <el-table-column prop="commissionRate" label="提成比例" width="240px">
            <template slot-scope="scope">
              <template v-if="scope.row.role === '司机'">{{ scope.row.commissionRate }}%</template>

              <template v-else>
                <el-input-number
                  v-model="scope.row.commissionRate"
                  :min="0"
                  :max="100"
                  :precision="2"
                  placeholder="请输入提成比例"
                  @change="updateDriverRate(newUserTableData)"
                />
                %
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!-- 老用户提成比例配置 -->
      <el-form-item label="老用户下单提成比例设置" required style="margin-top: 20px">
        <el-table :data="oldUserTableData" style="width: 100%" border>
          <el-table-column prop="role" label="角色" width="180px" />
          <el-table-column prop="commissionRate" label="提成比例" width="240px">
            <template slot-scope="scope">
              <template v-if="scope.row.role === '司机'">{{ scope.row.commissionRate }}%</template>

              <template v-else>
                <el-input-number
                  v-model="scope.row.commissionRate"
                  :min="0"
                  :max="100"
                  :precision="2"
                  placeholder="请输入提成比例"
                  @change="updateDriverRate(oldUserTableData)"
                />
                %
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="他人承运佣金比例设置" prop="otherRate">
        <el-input-number
          v-model="form.otherRate"
          :min="0"
          :max="100"
          :precision="2"
          placeholder="请输入"
        />
        %
      </el-form-item>

      <el-form-item label="供应商" required>
        <div class="transfer">
          <el-transfer
            v-model="form.merchantIds"
            :data="merchantList"
            filterable
            :titles="['供应商', '选中供应商']"
          />
        </div>
      </el-form-item>
    </el-form>

    <div class="footer">
      <el-button @click="back">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </basic-container>
</template>

<script>
  import { getAllMerchantList } from '@/api/public'
  import { detail, addOrEdit } from '@/api/driverCommission'

  export default {
    name: 'DriverCommissionAddOrEdit',
    data() {
      return {
        loading: false,
        form: {
          merchantIds: []
        },
        merchantList: [],
        newUserTableData: [
          { role: '平台', commissionRate: 0 },
          { role: '供应商', commissionRate: 0 },
          { role: '司机', commissionRate: 100 }
        ],
        oldUserTableData: [
          { role: '平台', commissionRate: 0 },
          { role: '供应商', commissionRate: 0 },
          { role: '司机', commissionRate: 100 }
        ],
        rules: {
          ruleName: [
            {
              required: true,
              message: '请输入提成规则名称',
              trigger: 'blur'
            },
            {
              pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s\-.,!?;:"'()\[\]{}<>]+$/,
              message: '只能输入汉字、数字、英文字符和标点符号',
              trigger: 'blur'
            }
          ],
          otherRate: [
            {
              required: true,
              message: '请输入他人承运佣金比例',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    mounted() {
      this.getMerchantList()

      const { id } = this.$route.params
      id && this.getDetail()
    },
    methods: {
      getDetail() {
        this.loading = true

        detail(this.$route.params.id).then((res) => {
          if (res.code === 0) {
            const {
              newUserDriverRate,
              newUserPlatformRate,
              newUserMerchantRate,
              oldUserMerchantRate,
              oldUserPlatformRate,
              oldUserDriverRate
            } = res.data

            this.newUserTableData[0].commissionRate = newUserPlatformRate
            this.newUserTableData[1].commissionRate = newUserMerchantRate
            this.newUserTableData[2].commissionRate = newUserDriverRate
            this.oldUserTableData[0].commissionRate = oldUserPlatformRate
            this.oldUserTableData[1].commissionRate = oldUserMerchantRate
            this.oldUserTableData[2].commissionRate = oldUserDriverRate

            this.form = res.data
            this.loading = false
          }
        })
      },
      getMerchantList() {
        getAllMerchantList().then((res) => {
          if (res.code !== 0) {
            return
          }
          this.merchantList = res.data.map((item) => ({
            label: item.name,
            key: item.id
          }))
        })
      },

      // 计算司机提成比例
      updateDriverRate(data) {
        const platformItem = data.find((item) => item.role === '平台')
        const supplierItem = data.find((item) => item.role === '供应商')
        const driverItem = data.find((item) => item.role === '司机')

        if (platformItem && supplierItem && driverItem) {
          const platform = platformItem.commissionRate || 0
          const supplier = supplierItem.commissionRate || 0
          // 直接计算司机提成比例，允许负数显示
          driverItem.commissionRate = 100 - platform - supplier
        }
      },
      confirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const newDriverItem = this.newUserTableData.find((item) => item.role === '司机')
            const newMerchantItem = this.newUserTableData.find((item) => item.role === '供应商')
            const newPlatformItem = this.newUserTableData.find((item) => item.role === '平台')
            const oldDriverItem = this.oldUserTableData.find((item) => item.role === '司机')
            const oldMerchantItem = this.oldUserTableData.find((item) => item.role === '供应商')
            const oldPlatformItem = this.oldUserTableData.find((item) => item.role === '平台')
            const newDriverRate = newDriverItem ? newDriverItem.commissionRate : 0
            const oldDriverRate = oldDriverItem ? oldDriverItem.commissionRate : 0

            // 判断司机提成比例是否为负数

            if (newDriverRate < 0 || oldDriverRate < 0) {
              this.$message.error('请输入0-100的数字')
              return
            }

            // 验证是否选择了供应商
            if (!this.form.merchantIds || this.form.merchantIds.length === 0) {
              this.$message.error('请选择供应商')
              return
            }

            const params = {
              id: this.form.id || '',
              ruleName: this.form.ruleName,
              otherRate: this.form.otherRate,
              newUserMerchantRate: newMerchantItem.commissionRate,
              newUserPlatformRate: newPlatformItem.commissionRate,
              oldUserMerchantRate: oldMerchantItem.commissionRate,
              oldUserPlatformRate: oldPlatformItem.commissionRate,
              merchantIds: this.form.merchantIds
            }
            this.loading = true

            addOrEdit(params).then((res) => {
              if (res.code === 0) {
                this.$message.success('操作成功')
                this.$router.go(-1)
              }
              this.loading = false
            })
          }
        })
      },
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1
      },

      back() {
        if (this.$route.params.id) {
          this.$router.go(-1)
        } else {
          this.$confirm('是否放弃本次输入？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.go(-1)
          })
        }

        this.form = {
          merchantIds: []
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form {
    padding-bottom: 60px;
  }
  .transfer {
    display: flex;

    ::v-deep .el-transfer-panel {
      width: 300px;
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 0;
    background-color: #fff;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
</style>
